// client/src/utils/marketerOngoingCache.js

const CACHE_PREFIX = 'MARKETER_ONGOING_';
const CACHE_TTL = 5 * 60 * 1000; // 5분

// sessionStorage 헬퍼
const ss = typeof window !== 'undefined' ? window.sessionStorage : null;

function cacheSet(key, value) {
  if (!ss) return;
  try {
    ss.setItem(key, JSON.stringify({
      data: value,
      timestamp: Date.now(),
      uid: window.__ME__?.id  // ✅ 사용자 ID 함께 저장
    }));
  } catch (e) {
    console.error('캐시 저장 실패:', e);
  }
}

function cacheGet(key) {
  if (!ss) return null;
  try {
    const cached = ss.getItem(key);
    if (!cached) return null;
    
    const { data, timestamp, uid } = JSON.parse(cached);
    
    // ✅ TTL 체크
    if (Date.now() - timestamp > CACHE_TTL) {
      ss.removeItem(key);
      return null;
    }
    
    // ✅ 사용자 검증
    const currentUid = window.__ME__?.id;
    
    // ✅ currentUid가 없으면 null 반환 (로그인 전이므로 캐시 사용 불가)
    if (!currentUid) {
      return null;
    }
    
    // ✅ currentUid가 있는데 캐시 uid와 다르면 삭제
    if (uid && uid !== currentUid) {
      console.warn('캐시 사용자 불일치, 삭제:', key);
      ss.removeItem(key);
      return null;
    }
    
    return data;
  } catch (e) {
    console.error('캐시 조회 실패:', e);
    return null;
  }
}

// 진행중인 프로젝트 목록 캐시
export function cacheOngoingProjectList(uid, projects) {
  cacheSet(`${CACHE_PREFIX}LIST:${uid}`, projects);
}

export function readOngoingProjectList(uid) {
  return cacheGet(`${CACHE_PREFIX}LIST:${uid}`);
}

// 캐시 초기화
export function clearOngoingCache(uid) {
  if (!ss) return;
  try {
    const keys = Object.keys(ss);
    keys.forEach(key => {
      if (key.startsWith(CACHE_PREFIX)) {
        ss.removeItem(key);
      }
    });
    console.log('진행중인 프로젝트 캐시 초기화 완료');
  } catch (e) {
    console.error('캐시 초기화 실패:', e);
  }
}

// 캐시 무효화 (특정 프로젝트)
export function invalidateOngoingCache(uid) {
  if (!ss) return;
  try {
    ss.removeItem(`${CACHE_PREFIX}LIST:${uid}`);
    console.log('진행중인 프로젝트 목록 캐시 무효화 완료');
  } catch (e) {
    console.error('캐시 무효화 실패:', e);
  }
}

